var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_102_629)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.8798 11.7542C39.7824 9.62524 39.4443 8.17139 38.9499 6.89941C38.4479 5.56488 37.6605 4.35608 36.6431 3.35693C35.6442 2.33948 34.4351 1.55182 33.1006 1.0495C31.8283 0.55542 30.3748 0.21759 28.2458 0.12085C26.113 0.0231934 25.4315 0 20 0C14.5685 0 13.887 0.0231934 11.7542 0.120239C9.62524 0.21759 8.17169 0.555725 6.89941 1.05011C5.56488 1.55212 4.35608 2.33948 3.35693 3.35693C2.33948 4.35577 1.55182 5.56458 1.0495 6.89911C0.55542 8.17139 0.21759 9.62524 0.12085 11.7538C0.0231934 13.887 0 14.5682 0 19.9997C0 25.4315 0.0231934 26.113 0.12085 28.2458C0.217895 30.3745 0.55603 31.8283 1.05041 33.1006C1.55243 34.4348 2.33978 35.6439 3.35724 36.6428C4.35608 37.6602 5.56519 38.4476 6.89972 38.9496C8.17169 39.4443 9.62555 39.7821 11.7545 39.8795C13.8876 39.9768 14.5688 39.9997 20.0003 39.9997C25.4318 39.9997 26.1133 39.9768 28.2462 39.8795C30.3751 39.7821 31.8286 39.4443 33.1009 38.9496C35.7874 37.9108 37.9111 35.787 38.9499 33.1006C39.4446 31.8283 39.7824 30.3745 39.8798 28.2458C39.9768 26.1127 40 25.4315 40 20C40 14.5682 39.9768 13.887 39.8798 11.7542ZM36.2796 28.082C36.1908 30.032 35.8649 31.091 35.5911 31.7957C34.9182 33.54 33.5397 34.9185 31.7953 35.5914C31.0907 35.8652 30.0317 36.1911 28.0817 36.2799C25.9732 36.3763 25.3406 36.3965 20 36.3965C14.6591 36.3965 14.0268 36.3763 11.918 36.2799C9.96826 36.1911 8.9093 35.8652 8.20435 35.5914C7.33582 35.2707 6.54999 34.7595 5.90485 34.0952C5.24048 33.45 4.72931 32.6645 4.40857 31.7957C4.13483 31.091 3.8089 30.032 3.72009 28.082C3.62396 25.9732 3.60352 25.3406 3.60352 20.0003C3.60352 14.6597 3.62396 14.0274 3.72009 11.9183C3.8092 9.96826 4.13483 8.9093 4.40857 8.20465C4.72931 7.33582 5.24078 6.54999 5.90485 5.90485C6.54999 5.24048 7.33582 4.72931 8.20465 4.40887C8.9093 4.13483 9.96826 3.8092 11.9183 3.72009C14.0271 3.62396 14.6597 3.60352 20 3.60352H19.9997C25.34 3.60352 25.9726 3.62396 28.0817 3.7204C30.0317 3.8092 31.0904 4.13513 31.7953 4.40887C32.6639 4.72961 33.4497 5.24078 34.0948 5.90485C34.7592 6.54999 35.2704 7.33582 35.5908 8.20465C35.8649 8.9093 36.1908 9.96826 36.2796 11.9183C36.3757 14.0271 36.3962 14.6597 36.3962 20C36.3962 25.3406 36.376 25.9729 36.2796 28.082Z",
    fill: "url(#paint0_linear_102_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9996 9.72961C14.3276 9.72961 9.72949 14.328 9.72949 20C9.72949 25.672 14.3276 30.2701 19.9996 30.2701C25.6719 30.2701 30.27 25.672 30.27 20C30.27 14.328 25.6719 9.72961 19.9996 9.72961ZM19.9996 26.6666C16.3179 26.6663 13.333 23.6816 13.3333 19.9997C13.3333 16.3181 16.3179 13.3331 19.9999 13.3331C23.6818 13.3334 26.6664 16.3181 26.6664 19.9997C26.6664 23.6816 23.6815 26.6666 19.9996 26.6666Z",
    fill: "url(#paint1_linear_102_629)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.076 9.32404C33.076 10.6494 32.0015 11.7239 30.6761 11.7239C29.3504 11.7239 28.2759 10.6494 28.2759 9.32404C28.2759 7.99835 29.3504 6.92383 30.6761 6.92383C32.0015 6.92383 33.076 7.99835 33.076 9.32404Z",
    fill: "url(#paint2_linear_102_629)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_629",
    x1: 3.35673,
    y1: 36.6429,
    x2: 36.6433,
    y2: 3.35641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D800B9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_102_629",
    x1: 12.7376,
    y1: 27.262,
    x2: 27.2619,
    y2: 12.7377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF0100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FD0056"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_102_629",
    x1: 28.979,
    y1: 11.0209,
    x2: 32.373,
    y2: 7.62688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F30072"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E50097"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_102_629"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.713dedcd917489c007292862e33abf3a.svg";
export { ForwardRef as ReactComponent };